import React from "react";
import { Button } from "antd";
import sharedStyles from "./sharedStyles";

const Primary = ({
    children,
    size = "default",
    ...otherProps
}: {
    children: any;
    size?: keyof typeof sharedStyles.size;
}) => {
    const appliedSize = sharedStyles.size[size];
    return (
        <Button type="primary" {...appliedSize} {...otherProps}>
            {children}
        </Button>
    );
};

export default Primary;
